import { UI_Spinner } from 'ui/components/1-atoms/Media/Spinner/Spinner';
import { UI_Button, UI_ButtonProps } from 'ui/components/1-atoms/Action/Button/Button';
import styles from './Filter.module.scss';

export interface UI_FilterProps {
	items: UI_ButtonProps[];
}

export const UI_Filter: React.FC<UI_FilterProps> = ({ items }) => {
	return !items?.length ? (
		<UI_Spinner />
	) : (
		<div className={styles.Filter}>
			{items.map((item, index) => (
				<UI_Button style="filter" key={index} {...item}>
					{item.children}
				</UI_Button>
			))}
		</div>
	);
};
